import React, { FC } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { withUserType } from '../withUserType';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import SubnavTabs from '../subnav_tabs/SubnavTabs';

const { Content } = Layout;

/**
 * Shell for Agent Operating Procedures, mirroring the Troubleshooting page: the
 * navblock header, then the child routes. Landing on the base path redirects to
 * `/overview`, so the sidebar entry always lands somewhere concrete and the
 * overview remounts — and refetches — on every visit.
 */
const AOPPage: FC<any> = ({ childRoutes, userType, companyConfig }): React.ReactElement => {
	const basePath = `/${userType}/workflows/agent_operating_procedures`;

	return (
		<div>
			<Route
				path={basePath}
				exact={true}
				render={() => <Redirect to={{ pathname: `${basePath}/overview` }} />}
			/>
			<Content className="projectsPage" style={{ padding: '0 0.5em' }}>
				<div
					style={{
						margin: '0 -8px',
						padding: '24px',
						paddingBottom: 0,
						background: nullSafeGet('detail.config.theme.navblock', companyConfig),
						marginBottom: 8,
					}}
				>
					<div style={{ marginBottom: 24 }}>
						<h4 style={{ color: 'rgba(255, 255, 255, 0.9)', marginRight: 8, marginBottom: 0 }}>
							Agent Operating Procedures
						</h4>
					</div>
					<SubnavTabs tabs={[]} onChange={() => {}} isActive={() => {}} />
				</div>
				{childRoutes.map((route, index) => (
					<RouteWithSubRoutes key={index} {...route} />
				))}
			</Content>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
});

export default withUserType(connect(mapStateToProps)(AOPPage as any) as any);
